<template>
  <div class="MyOrder">
    <ul class="tagList">
      <li
        :class="{ selected: form_head_uuid === item.form_head_uuid }"
        v-for="(item, index) in tagList"
        :key="'tag' + index"
        @click="changeIndex(item.form_head_uuid)"
      >
        {{ item.name }}
      </li>
    </ul>
    <template v-if="show">
      <ApprovalList
        v-if="
          [
            '403e15205bc248f48d8a3626571c4e56',
            '91e9bb4eac0a48b38e8327cc9c6c23de',
            '33d336e546644de7afb25e1989757d93'
          ].includes(form_head_uuid)
        "
        :form_head_uuid="form_head_uuid"
      />
      <template v-else>
        <div class="orderBox" v-if="orderList && orderList.length > 0">
          <div class="orderTableHeader">
            <span>商品</span>
            <span>单价</span>
            <span>数量</span>
            <span>总价</span>
          </div>
          <ul class="orderList">
            <li v-for="item in orderList" :key="'order' + item.id">
              <div class="orderHeader">
                <span class="orderTime">{{ item.l0u3cwjsdrbnhuth }}</span>
                <span class="orderId">
                  {{ '订单号：' + item['5rh34ajk852uufsx'] }}
                </span>
              </div>
              <div
                class="orderDetail"
                v-for="(order, idx) in item.cpimejxmehpaxrrz"
                :key="idx"
              >
                <img
                  :src="
                    order.mnkt8dkjryhvdej3 && order.mnkt8dkjryhvdej3.length > 0
                      ? order.mnkt8dkjryhvdej3[0].url
                      : ''
                  "
                  alt="商品图片"
                />
                <div class="goodsName">
                  <p
                    @click.stop="
                      navTo('/mall/goods/' + order.whfmbyuc1i2pavi4[0].id)
                    "
                    v-if="
                      order.whfmbyuc1i2pavi4 &&
                      order.whfmbyuc1i2pavi4.length > 0
                    "
                  >
                    {{ order.whfmbyuc1i2pavi4[0].value }}
                  </p>
                </div>
                <span class="unitPrice">
                  {{ '￥' + (order.rojkudmmvpzinpar || 0) }}
                </span>
                <span class="num">
                  {{ order.mcuilzaudpe3shlc }}
                  {{
                    order.kq1qbbk7dulmlghs ? `(${order.kq1qbbk7dulmlghs})` : ''
                  }}
                </span>
                <span class="num">{{ '￥' + order.nvbfzg88gv88hnt9 }}</span>
                <span class="status" v-if="idx === 0">
                  <img
                    src="@/assets/img/dfh.svg"
                    alt=""
                    v-if="
                      item.skwyvudrzzk6oljg ===
                      '6773a3b6-26c8-41d9-a2fe-26d73f0fa8f8'
                    "
                  />
                  <img
                    src="@/assets/img/ysh.svg"
                    alt=""
                    v-else-if="
                      item.skwyvudrzzk6oljg ===
                      'ed990658-9190-491e-bc87-8311a7dcb31c'
                    "
                  />
                  <img
                    src="@/assets/img/shz.svg"
                    alt=""
                    v-else-if="
                      item.skwyvudrzzk6oljg ===
                      'a84d211b-2bc0-4c24-8a45-01fc249e5a5a'
                    "
                  />
                  <img
                    src="@/assets/img/dsh.svg"
                    alt=""
                    v-else-if="
                      item.skwyvudrzzk6oljg ===
                      '1c10fa79-0b9d-4892-9be8-03daad9ffe8b'
                    "
                  />
                  <img
                    src="@/assets/img/ywc.svg"
                    alt=""
                    v-else-if="
                      item.skwyvudrzzk6oljg ===
                      '898c47e2-acdc-41a7-b63b-c42cc1eda346'
                    "
                  />
                  <img
                    src="@/assets/img/yqx.svg"
                    alt=""
                    v-else-if="
                      item.skwyvudrzzk6oljg ===
                      'b2434af8-3618-4a37-aeb2-55aea65f3bb6'
                    "
                  />
                  <img
                    src="@/assets/img/underReview.svg"
                    alt=""
                    v-else-if="
                      item.lzmpjqms8ynktnxi ===
                      '02c5ca9e-3252-456e-8d51-6ff370f4b2c8'
                    "
                  />
                  <img
                    src="@/assets/img/success.svg"
                    alt=""
                    v-else-if="
                      item.lzmpjqms8ynktnxi ===
                      'bf8f4aa2-016c-488f-9732-5ab12d354d69'
                    "
                  />
                  <img
                    src="@/assets/img/fail.svg"
                    alt=""
                    v-else-if="
                      item.skwyvudrzzk6oljg ===
                      '657f2655-9bde-4ca5-a0a1-1f7c4aa93a43'
                    "
                  />
                </span>
                <template v-if="idx === 0">
                  <button
                    v-if="
                      item.lzmpjqms8ynktnxi ===
                      '8abf497b-d388-4ea5-a2f2-2813578853f9'
                    "
                    @click="initiateAudit(item)"
                  >
                    发起审核
                  </button>
                </template>
              </div>
              <div class="orderfooter">
                <div>
                  <template>
                    总金额：{{ '￥' + item.p6zxciihiw61mebe }}
                  </template>
                </div>
                <div>
                  <el-button
                    type="primary"
                    v-if="
                      item.skwyvudrzzk6oljg ===
                      '1c10fa79-0b9d-4892-9be8-03daad9ffe8b'
                    "
                    @click="confirmReceiptGoods(item)"
                  >
                    确认收货
                  </el-button>
                  <template
                    v-if="
                      item.skwyvudrzzk6oljg ===
                      '898c47e2-acdc-41a7-b63b-c42cc1eda346'
                    "
                  >
                    <el-button
                      v-if="
                        item.b8lqe9bvzid6twwc !==
                          'f16a9ec4-ef71-4b9c-aa85-f02d1b440226' &&
                        (item.aliweixqekq3uo2s !==
                          '8ef31faf-5153-4fd4-ab5e-2b6599ce8d64' ||
                          item.kgwambu2gnj2clcn ===
                            'fa090b14-a3ee-4eac-89c2-32cfc12c5619')
                      "
                      @click="
                        navTo(`/mall/orderDetail/${item.id}?type=returnGoods`)
                      "
                    >
                      退货
                    </el-button>
                    <el-button
                      @click="navTo(`/mall/orderDetail/${item.id}?type=barter`)"
                      v-if="
                        item.aliweixqekq3uo2s !==
                          '8ef31faf-5153-4fd4-ab5e-2b6599ce8d64' &&
                        item.b8lqe9bvzid6twwc !==
                          'f16a9ec4-ef71-4b9c-aa85-f02d1b440226'
                      "
                    >
                      换货
                    </el-button>
                  </template>
                  <!-- 取消订单 订单状态 审核中 审核成功 审核失败  -->
                  <el-button
                    v-if="
                      [
                        'a84d211b-2bc0-4c24-8a45-01fc249e5a5a',
                        'ed990658-9190-491e-bc87-8311a7dcb31c',
                        '657f2655-9bde-4ca5-a0a1-1f7c4aa93a43'
                      ].includes(item.skwyvudrzzk6oljg)
                    "
                    @click="cancelAnOrder(item)"
                  >
                    取消订单 {{ item.lzmpjqms8ynktnxi }}
                  </el-button>
                  <el-button @click="navTo('/mall/orderDetail/' + item.id)">
                    查看详情
                  </el-button>
                </div>
              </div>
            </li>
          </ul>
          <div class="pagination">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="page"
              :page-sizes="[10, 20, 40, 80]"
              :page-size="limit"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total"
            >
            </el-pagination>
          </div>
        </div>
        <p class="emptyTips" v-else>
          <img src="../../assets/img/order.svg" alt="" />
        </p>
      </template>
    </template>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Popup from "../../components/Popup";
import { online, children, execButton, getFormRowApproveList, setApproveClose } from "@/api/platform";
import ApprovalList from '@/components/ApprovalList.vue';
export default {
  name: "MyOrder",
  components: {
    Popup,
    ApprovalList,
  },
  computed: {
    ...mapState(["clientToken"]),
  },
  data () {
    return {
      tagList: [
        { name: "全部订单", form_head_uuid: "58a2be48484e436dbbb28fd778406de6", },
        { name: "审核中", form_head_uuid: "403e15205bc248f48d8a3626571c4e56" },
        { name: "审核成功", form_head_uuid: "91e9bb4eac0a48b38e8327cc9c6c23de", },
        { name: "审核失败", form_head_uuid: "33d336e546644de7afb25e1989757d93", },
        { name: "待发货", form_head_uuid: "42c3b2c71c83420095614efde43e4cea", },
        { name: "待收货", form_head_uuid: "7713093266f64911bb3ef4b14c58affc", },
        { name: "已完成", form_head_uuid: "e9667bbbf7d942cea48e531fd58b7142", },
      ],
      status: [
        {
          color: "#B5BAC2",
          label: "待审批",
          value: "989059b3-6972-4174-8f34-cdc5699bcb8f",
          front_color: "#fff",
        },
        {
          color: "#629FF1",
          label: "审批中",
          value: "02c5ca9e-3252-456e-8d51-6ff370f4b2c8",
          front_color: "#fff",
        },
        {
          color: "#76D375",
          label: "审批成功",
          value: "bf8f4aa2-016c-488f-9732-5ab12d354d69",
          front_color: "#fff",
        },
        {
          color: "#FA7066",
          label: "审批驳回",
          value: "8abf497b-d388-4ea5-a2f2-2813578853f9",
          front_color: "#fff",
        },
        {
          color: "#F7C844",
          label: "待总集确认",
          value: "adb2fb19-66e7-4445-918e-5da857fb474c",
          front_color: "#fff",
        },
        {
          color: "#FFE5B1",
          label: "总集已确认",
          value: "a225c470-4d40-4c37-9870-09726155a478",
          front_color: "#fff",
        },
      ],
      form_head_uuid: "58a2be48484e436dbbb28fd778406de6",
      orderList: [],
      popupShow: false,
      curOrderId: "",
      curCommentGoodsId: "",
      curCommentGoodsDetailId: "",
      curStar: 0,
      hasClickStar: false,
      comment: "",
      //分页
      page: 1,
      total: 0,
      limit: 20,
      show: true,
    };
  },
  created () {
  },
  mounted () {
    this.getOrderList();
  },
  methods: {
    // 获取订单列表
    async getOrderList () {
      const { form_head_uuid, page, limit } = this;
      const { meta, result } = await online({
        form_head_uuid,
        page,
        limit,
        keyword: "",
        select_option: "",
      });
      let list = await Promise.all(
        result.map(async (el) => ({
          ...el,
          cpimejxmehpaxrrz: await this.children(el.id),
        }))
      );
      this.orderList = list;
      this.total = meta.total;
    },
    // 获取子表数据
    async children (record_id) {
      const { form_head_uuid } = this;
      const { result } = await children({
        page: 1,
        limit: 100,
        field_uuid: "00f98dceac054e8fb727092a99fc5a3d",
        form_head_uuid,
        record_id,
      });
      return result;
    },
    // 切换页数
    handleCurrentChange (page) {
      this.page = page;
      this.getOrderList();
    },
    handleSizeChange (limit) {
      this.page = 1;
      this.limit = limit;
      this.getOrderList();
    },
    changeIndex (form_head_uuid) {
      this.page = 1;
      this.form_head_uuid = form_head_uuid;

      if (['403e15205bc248f48d8a3626571c4e56', '91e9bb4eac0a48b38e8327cc9c6c23de', '33d336e546644de7afb25e1989757d93'].includes(form_head_uuid)) {
        this.show = false;
        setTimeout(() => {
          this.show = true;
        }, 300)
      } else {
        this.show = true
        this.getOrderList();
      }
    },
    navTo (route) {
      this.$router.push(route);
      this.$store.commit('setData', {
        form_head_uuid: this.form_head_uuid
      })
    },

    // 确认收货
    async confirmReceiptGoods ({ id }) {
      await execButton({
        button_uuid: "ab6a5764-7f39-43d9-b4f9-6d47a3ea30b8",
        form_head_uuid: "7713093266f64911bb3ef4b14c58affc",
        id,
        type: 2,
      });
      this.page = 1;
      this.$notify({
        title: "提示",
        message: "收货成功",
        type: "success",
      });
      setTimeout(() => {
        this.getOrderList();
      }, 2000);
    },
    initiateAudit ({ id }) {
      this.$confirm("确认要重新发起审核?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          await execButton({
            button_uuid: "e5740381-1dae-49c4-aaa9-5f35f8df10c6",
            form_head_uuid: "7713093266f64911bb3ef4b14c58affc",
            id,
            type: 2,
          });
          this.$notify({
            title: "提示",
            message: "发起成功",
            type: "success",
          });
          this.page = 1;
          setTimeout(() => {
            this.getOrderList();
          }, 2000);
        })
        .catch(() => { });
    },
    // 取消订单
    cancelAnOrder ({ id }) {
      this.$confirm("确认要取消订单?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          await execButton({
            button_uuid: "7b388e44-8bfb-4fb7-b312-a03a1bca2369",
            form_head_uuid: this.form_head_uuid,
            id,
            type: 2,
          });
          this.$notify({
            title: "提示",
            message: "取消订单成功",
            type: "success",
          });
          setTimeout(() => {
            this.getOrderList();
            this.getFormRowApproveList(id)
          }, 2000);
        })

    },
    async getFormRowApproveList (form_row_uuid) {
      const { result } = await getFormRowApproveList({
        applicationid: '270ab0c29e5411ee9b8b0242321230b4',
        form_uuid: '436ae44d1c60475a9b4009ca40edc11e',
        form_row_uuid
      })
      if (result.data && result.data.list && result.data.list.length > 0) {
        this.setApproveClose(result.data.list[0].id)
      }
    },

    async setApproveClose (approve_id) {
      await setApproveClose({
        applicationid: '270ab0c29e5411ee9b8b0242321230b4',
        approve_id
      })
    }
  },
};
</script>

<style scoped lang="less">
@import '../../assets/css/var.less';
@import '../../css/order.less';
.MyOrder {
  .tagList {
    li {
      text-align: center;
      display: inline-block;
      font-weight: 550;
      font-size: 18px;
      border-bottom: 2px solid @borderColor;
      cursor: pointer;
      padding: 10px 20px;
      position: relative;
      &:after {
        top: 12px;
        right: 0;
        position: absolute;
        content: '';
        width: 1px;
        height: 15px;
        background-color: @borderColor;
      }
      &:last-child {
        &:after {
          display: none;
        }
      }
    }
    .selected {
      color: @thirdColor;
      border-bottom: 2px solid @thirdColor;
    }
  }
  .popupContent {
    padding: 10px;
    .scoreBox {
      width: 100%;
      height: 50px;
      position: relative;
      line-height: 50px;
      text-align: left;
      .tips {
        font-size: 15px;
        vertical-align: middle;
        display: inline-block;
      }
      i {
        cursor: pointer;
        vertical-align: middle;
        display: inline-block;
        font-size: 25px;
        margin-right: 5px;
        -webkit-text-stroke: 1px #f9bd4f;
      }
    }
    textarea {
      width: 400px;
      height: 80px;
      padding: 5px;
      border: 1px solid @borderColor;
      display: block;
      margin-top: 10px;
    }
    button {
      display: block;
      margin: 10px auto;
      width: 70px;
      height: 30px;
      border-radius: 3px;
      background-color: #313541;
      color: white;
      border: none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/client/MyOrder.vue